/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Freeze_Blocked_Already_UsedInputs */

const fr_membership_freeze_blocked_already_used = /** @type {(inputs: Membership_Freeze_Blocked_Already_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pause déjà utilisée sur cette année de contrat. Prochaine pause possible à partir du ${i?.date}, date de reconduction.`)
};

/**

* @param {Membership_Freeze_Blocked_Already_UsedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_blocked_already_used = /** @type {((inputs: Membership_Freeze_Blocked_Already_UsedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Blocked_Already_UsedInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_blocked_already_used(inputs)
});